import React, { useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DropdownSelect from "../common/DropdownSelect";
import "../../styles/admin/TeacherAssignForm.scss";

const CourseSelectForm = ({
  isOpen,
  onClose,
  onSubmit,
  courses = [],
  title = "Add Courses",
}) => {
  const courseOptions = useMemo(
    () =>
      (courses || []).map((c) => ({
        key: c?.key,
        value: c.id ?? c.value ?? c,
        label: c.name ?? c.label ?? String(c),
      })),
    [courses]
  );

  const [selectedCourses, setSelectedCourses] = useState([]);
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      courseIds: selectedCourses?.map((c) => c.key),
    };
    onSubmit && onSubmit(payload);
  };

  return (
    <div className="assign-form-overlay">
      <div className="assign-form-container">
        <div className="assign-form-header">
          <h2>{title}</h2>
          <button
            className="assign-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <form className="assign-form" onSubmit={handleSubmit}>
          <div
            className={`assign-form-group ${errors.courses ? "has-error" : ""}`}
          >
            <label htmlFor="courses-select">Courses</label>
            <DropdownSelect
              inputId="courses-select"
              isMulti
              options={courseOptions}
              value={selectedCourses}
              onChange={(vals) => setSelectedCourses(vals || [])}
              placeholder="Select courses"
              searchable
            />
            {errors.courses && (
              <span className="assign-error-message">{errors.courses}</span>
            )}
          </div>

          <div className="assign-form-actions">
            <button
              type="button"
              className="assign-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="assign-submit-button btn-interactive"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CourseSelectForm;
